import React from 'react';
import ArticleLayout from '../components/site/ArticleLayout';
import useLang from '../i18n/useLang';
import blog7 from '../images/blog7.webp';

// This post is written in Hebrew only, so it stays right-to-left on the English site too.
const BlogSchneiderElectricHebrew = () => {
  const { t } = useLang();

  return (
    <ArticleLayout
      title="מפעל מסורתי שהפך למגדלור עולמי של חדשנות? כן, זה אפשרי."
      lead="(וזו ההוכחה שתעשייה 4.0 היא לא באזז אלא מציאות מתקדמת)"
      image={blog7}
      imageAlt="Schneider Electric Factory"
      author={t('blogs.blogMaimPage.Yuval')}
      date="2025-05-18"
      dir="rtl"
      lang="he"
    >
      <p>
        מפעל של Schneider Electric בצרפת עשה את הבלתי ייאמן:
        הוא הפך ממפעל ייצור בן 50 למפעל חכם שהוכר ע"י הפורום הכלכלי העולמי כ-Lighthouse Factory.
      </p>

      <h2>מה הוא עשה אחרת?</h2>
      <ul>
        <li>חיישני IoT על כל ציוד הייצור</li>
        <li>אלגוריתמים של AI לתחזוקה חזויה</li>
        <li>מערכות AR בטאבלטים ומשקפיים חכמים לעובדים</li>
        <li>תאומים דיגיטליים לכל מערכות התשתית</li>
        <li>אופטימיזציה של אנרגיה, מים ושרשרת האספקה</li>
      </ul>

      <h2>והתוצאות?</h2>
      <ul>
        <li>חיסכון של 25% באנרגיה</li>
        <li>צמצום 64% בצריכת מים</li>
        <li>ירידה של 30% בעלויות תחזוקה</li>
        <li>שיפור דרמטי ב-OEE ובאיכות</li>
      </ul>

      <h2>וכל זה לא קרה במקרה.</h2>
      <p>
        <strong>המפתח?</strong> לחשוב בגדול, להתחיל בקטן, ולהתרחב מהר
      </p>
      <p>
        הם התחילו בפיילוטים קטנים,
        הוכיחו ROI תוך שבועות,
        והרחיבו את המודלים לכלל המפעל (ומעבר לו).
      </p>

      <h2>הם לא רק שדרגו טכנולוגית את הייצור</h2>
      <p>
        הם גם העצימו את העובדים, שיפרו את סביבת העבודה,
        ויצרו תרבות של שיפור מתמיד.
      </p>

      <h2>מה אפשר ללמוד מזה?</h2>
      <ul>
        <li>טרנספורמציה תעשייתית חייבת לשלב אנשים + טכנולוגיה</li>
        <li>כדאי להתחיל בקטן ולגדול מהר</li>
        <li>המפתח הוא אינטגרציה של מערכות – לא פתרון אחד</li>
      </ul>

      <p>
        האם גם אתם במסע של דיגיטציה תעשייתית?
        אשמח לשמוע בתגובות על אתגרים, הצלחות וסיפורים מהשטח.
      </p>
    </ArticleLayout>
  );
};

export default BlogSchneiderElectricHebrew;
